import { Box, Text } from '@bonanza-social/moonlight';
import { memo, useCallback, useMemo } from 'react';
import { Pressable } from 'react-native';
import { Trans } from '@bonanza-social/i18n';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';

function CloseAccount() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const onCustomerSupportPress = useCallback(() => {
    navigation.navigate('ContactUsScreen');
  }, [navigation]);

  const transComponents = useMemo(
    () => ({
      customerSupportLink: (
        <Text variant="body-m" color="darkSurfaceAccentSolid" />
      ),
    }),
    [],
  );

  return (
    <Box paddingTop="space-800" gap="space-600">
      <Pressable onPress={onCustomerSupportPress}>
        <Text variant="body-m" color="darkSurfacePrimary" textAlign="center">
          <Trans
            ns="account"
            i18nKey="myProfileSupportText"
            components={transComponents}
          />
        </Text>
      </Pressable>
    </Box>
  );
}

export default memo(CloseAccount);
